import { type OrderStatusEnum } from "@/config/apiClient.types";

type BadgeStatusVariantV2 = "success" | "warning" | "error" | "info";

export const getOrderBadgeStatus = (
  status: OrderStatusEnum
): BadgeStatusVariantV2 => {
  switch (status) {
    case "CANCELLED":
      return "error";
    case "DONE":
      return "success";
    case "DRAFT":
      return "info";
    default:
      return "warning";
  }
};
